export default {
  apiRoot: import.meta.env.VITE_API_ROOT ?? "/php",
  externalLinksRoot: import.meta.env.VITE_EXTERNAL_LINKS_ROOT ?? "",
  captchaUrl:
    (import.meta.env.VITE_EXTERNAL_LINKS_ROOT ?? "") +
    "/securimage/securimage_show.php",
  googleMapsApiKey: "AIzaSyAMQvBJe2fygp-7_aLgKBbXqtzdYwCjhwI",
  disableVueLogging: !!import.meta.env.VITE_DISABLE_VUE_LOGGING,
};
